import React, { PropTypes } from "react";

const AttachmentProgress = (props) => {
  return (
    <p className="file-progress">
      <span className="icon icon-file-empty" />
      <span
        className="upload-progress"
        style={{ width: props.progress ? `${props.progress}%` : "0px" }}
      />
    </p>
  );
};

AttachmentProgress.propTypes = {
  progress: PropTypes.number,
};

export default AttachmentProgress;



// WEBPACK FOOTER //
// ./src/components/common/attachments/AttachmentProgress.js